import React from 'react';
import PropTypes from 'prop-types';

const VirtualTerminal = ({ altText }) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='1.5em' height='1.5em' fill='none'>
      <title id='virtual-terminal-title'>{altText}</title>
      <path fill='currentColor' d='M6 6.25a.75.75 0 0 0-.75.75v3a.75.75 0 0 0 1.5 0V7.75H9a.75.75 0 0 0 0-1.5H6ZM12 10.25a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-1.5 0v-2a.75.75 0 0 1 .75-.75ZM9.75 10a.75.75 0 0 0-1.5 0v4a.75.75 0 0 0 1.5 0v-4ZM15 9.25a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-4a.75.75 0 0 1 .75-.75ZM6.75 14a.75.75 0 0 0-1.5 0v3c0 .414.336.75.75.75h3a.75.75 0 0 0 0-1.5H6.75V14ZM18 13.25a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-.75.75h-3a.75.75 0 0 1 0-1.5h2.25V14a.75.75 0 0 1 .75-.75ZM15 6.25a.75.75 0 0 0 0 1.5h2.25V10a.75.75 0 0 0 1.5 0V7a.75.75 0 0 0-.75-.75h-3Z'/>
      <path fill='currentColor' fillRule='evenodd' d='M6 3.25A3.75 3.75 0 0 0 2.25 7v10A3.75 3.75 0 0 0 6 20.75h12A3.75 3.75 0 0 0 21.75 17V7A3.75 3.75 0 0 0 18 3.25H6ZM3.75 7A2.25 2.25 0 0 1 6 4.75h12A2.25 2.25 0 0 1 20.25 7v10A2.25 2.25 0 0 1 18 19.25H6A2.25 2.25 0 0 1 3.75 17V7Z' clipRule='evenodd'/>
    </svg>
  );
};

VirtualTerminal.propTypes = {
  altText: PropTypes.string
};

export default VirtualTerminal;
